import { render, staticRenderFns } from "./CPreview.vue?vue&type=template&id=8f897cf8&"
import script from "./CPreview.vue?vue&type=script&lang=js&"
export * from "./CPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports